import { SquareLock01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

export const NoReportAccessView = () => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-6">
      <div className="w-16 h-16 bg-alpha-40 rounded-full flex items-center justify-center">
        <HugeiconsIcon
          icon={SquareLock01Icon}
          className="text-content-1000"
          size={24}
        />
      </div>
      <div className="space-y-1">
        <p className="text-center text-content-500 font-bold">
          You don’t have permission to view this report
        </p>
        <p className="text-center text-content-300">
          Please contact your administrator if you believe this is an error
        </p>
      </div>
    </div>
  );
};
